export const AIRVIEW_ORIGIN = 'https://airview.studio';
const MANAGED_HOSTS = new Set(['airview.studio', 'www.airview.studio', 'sightline.vaultlinesolutions.com']);

/** Public links keep the product's domain even when the app uses its compatibility origin. */
export function publicOrigin(origin: string): string {
  try {
    const url = new URL(origin);
    if (url.protocol === 'https:' && !url.port && !url.username && !url.password && MANAGED_HOSTS.has(url.hostname)) return AIRVIEW_ORIGIN;
  } catch { /* Rendering without a browser still supports root-relative links. */ }
  return origin;
}

export function publicUrl(path: `/${string}`, origin = typeof location !== 'undefined' ? location.origin : ''): string {
  return `${publicOrigin(origin)}${path}`;
}
